'use client';

import { TEST_TEXT, CROSS_LINE_WIDTH, CROSS_LINE_COLOR, LINE_HEIGHT, SPECIFIC_CHART, HOVER_COLOR, X_LABEL_HEIGHT } from '../../helper/config.js';
import '../../../_virtual/_tslib.js';
import drawing from '../../helper/drawing.js';

var props;
var tooltipDetail = {
    data: {},
    name: ''
};
function setProps(value) {
    props = value;
}
function fillLabelsInYAxis() {
    var ctx = props.ctx, chartNecessaryInformation = props.chartNecessaryInformation, chartInformation = props.chartInformation, config = props.config;
    var _a = (config === null || config === void 0 ? void 0 : config.axes) || {}, _b = _a.horizontalCrossLine, horizontalCrossLine = _b === void 0 ? true : _b, decorationForVerticalLabel = _a.decorationForVerticalLabel;
    var chartArea = chartNecessaryInformation.chartArea, yRange = chartNecessaryInformation.yRange, yLabelTextMaxLength = chartNecessaryInformation.yLabelTextMaxLength;
    var yAxis = chartInformation.yAxis;
    var chartEndingPointInXAxis = chartArea.chartEndingPointInXAxis, chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis;
    /*
     * Get text height
     * */
    var _c = ctx.measureText(TEST_TEXT), actualBoundingBoxAscent = _c.actualBoundingBoxAscent, actualBoundingBoxDescent = _c.actualBoundingBoxDescent;
    var textHeight = actualBoundingBoxAscent + actualBoundingBoxDescent;
    /*
     * Draw label and cross line
     * */
    var yLabelPosition = textHeight;
    var crossLinePosition = chartEndingPointInYAxis;
    ctx.beginPath();
    yAxis.forEach(function (number) {
        var displayLabel = decorationForVerticalLabel ? decorationForVerticalLabel(number) : number.toString();
        ctx.save();
        /*
         * Because i use text-align: right, so that i have to fillText by text max length
         * in x position. If not do that, text will go outside of the viewport
         * */
        ctx.textAlign = 'right';
        ctx.fillText(displayLabel, yLabelTextMaxLength, yLabelPosition);
        if (horizontalCrossLine) {
            ctx.save();
            ctx.moveTo(chartStartingPointInXAxis, crossLinePosition);
            ctx.lineTo(chartEndingPointInXAxis, crossLinePosition);
            ctx.setLineDash([5, 3]);
            ctx.lineWidth = CROSS_LINE_WIDTH;
            ctx.strokeStyle = CROSS_LINE_COLOR;
            ctx.stroke();
            ctx.restore();
        }
        ctx.restore();
        yLabelPosition += yRange;
        crossLinePosition += yRange;
    });
    ctx.closePath();
}
function fillLabelsInXAxis() {
    var ctx = props.ctx, chartNecessaryInformation = props.chartNecessaryInformation, chartInformation = props.chartInformation, config = props.config;
    var _a = config.axes || {}, decorationForVerticalLabel = _a.decorationForVerticalLabel, _b = _a.hideXAxis, hideXAxis = _b === void 0 ? false : _b;
    /*
     * Hide x-axis if it not enable
     * */
    if (hideXAxis) {
        return;
    }
    var type = config.chart.type;
    var chartArea = chartNecessaryInformation.chartArea, xRange = chartNecessaryInformation.xRange, xLabelTextMaxLength = chartNecessaryInformation.xLabelTextMaxLength;
    var chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis, chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis;
    var xAxis = chartInformation.xAxis;
    var labelYPosition = chartStartingPointInYAxis + X_LABEL_HEIGHT;
    var labelXPosition = chartStartingPointInXAxis;
    /*
     * Check single data
     * */
    if (!SPECIFIC_CHART.includes(type)) {
        labelXPosition += xRange / 2;
    }
    var xLabelSkipValue = Math.floor(xLabelTextMaxLength / xRange);
    var skipValue = 0;
    xAxis.forEach(function (item) {
        if (skipValue > 0) {
            skipValue -= 1;
            labelXPosition += xRange;
            return;
        }
        var displayLabel = decorationForVerticalLabel ? decorationForVerticalLabel(item) : item;
        var lineArray = drawing.wrapText(ctx, displayLabel.toString(), labelXPosition, labelYPosition, xRange, LINE_HEIGHT).lineArray;
        /*
         * Hidden text when x-range less than xLabelAdjacentSideWidth after rotate
         * */
        if (skipValue === 0) {
            lineArray.forEach(function (item) {
                ctx.save();
                ctx.textAlign = 'center';
                ctx.fillText(item[0].toString(), item[1], item[2]);
                ctx.restore();
            });
            labelXPosition += xRange;
            skipValue = xLabelSkipValue;
        }
    });
}
function hover() {
    /*
     * Get props and config
     * */
    var mouse = props.mouse, chartInformation = props.chartInformation, ctx = props.ctx, chartNecessaryInformation = props.chartNecessaryInformation, config = props.config;
    var type = config.chart.type;
    var chartArea = chartNecessaryInformation.chartArea, xRange = chartNecessaryInformation.xRange;
    var chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis, chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis;
    var data = chartInformation.data, xAxis = chartInformation.xAxis;
    /*
     * End get props and config
     * */
    var startingPosition = chartStartingPointInXAxis;
    xAxis.map(function (xItem, index) {
        var pointTo = xRange;
        if (SPECIFIC_CHART.includes(type)) {
            if (index === 0 || index === xAxis.length - 1) {
                pointTo = xRange / 2;
            }
        }
        if (mouse) {
            if (mouse.x >= startingPosition &&
                mouse.x <= startingPosition + pointTo &&
                mouse.y >= chartEndingPointInYAxis &&
                mouse.y <= chartStartingPointInYAxis) {
                /*
                 * Getting tooltip data
                 * */
                Object.assign(tooltipDetail, {
                    name: xItem,
                    data: data[xItem]
                });
                /*
                 * Draw the hover background
                 * */
                if (!SPECIFIC_CHART.includes(type)) {
                    ctx.beginPath();
                    ctx.save();
                    ctx.fillStyle = HOVER_COLOR;
                    ctx.fillRect(startingPosition, chartEndingPointInYAxis, pointTo, chartStartingPointInYAxis - chartEndingPointInYAxis);
                    ctx.restore();
                    ctx.closePath();
                }
            }
        }
        startingPosition += pointTo;
    });
}
function draw() {
    hover();
    fillLabelsInYAxis();
    fillLabelsInXAxis();
    return tooltipDetail;
}
var axes = {
    setProps: setProps,
    draw: draw
};

export { axes as default };
//# sourceMappingURL=axes.js.map
